import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASEURL + "/DigitalAssets";

export interface OnlineDirectoryResponse {
  brandName: string;
}

export const getOnlineDirectories = async (): Promise<OnlineDirectoryResponse[]> => {
  const response = await axios.get<OnlineDirectoryResponse[]>(
    `${API_BASE_URL}/OnlineDirectories`
  );
  return response.data;
};
